import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faTimesCircle,
  faInfoCircle,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import "./Notification.css";

const Notification = ({ title, description, status }) => {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    // reduce progress every 50ms
    const interval = setInterval(() => {
      setProgress((prev) => Math.max(prev - 1, 0));
    }, 50);

    const timeout = setTimeout(() => {
      clearInterval(interval);
    }, 5000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  const statusConfig = {
    success: {
      color: "#4caf50",
      icon: faCheckCircle,
    },
    error: {
      color: "#f44336",
      icon: faTimesCircle,
    },
    info: {
      color: "#2196f3",
      icon: faInfoCircle,
    },
    warning: {
      color: "#ff9800",
      icon: faExclamationTriangle,
    },
  };

  const { color, icon } = statusConfig[status] || statusConfig.info;

  return (
    <div className="notification">
      <div className="notification-header">
        <FontAwesomeIcon icon={icon} style={{ color, marginRight: "10px" }} />
        <h4>{title}</h4>
      </div>
      <p className="notification-description">{description}</p>

      <div
        className="notification-progress"
        style={{
          width: `${progress}%`,
          backgroundColor: progress > 0 ? color : "#ccc",
        }}
      ></div>
    </div>
  );
};

export default Notification;
